module.exports = __webpack_public_path__ + "img/dragon_nest_small.0f704cb5.png";